import { t } from '@lingui/core/macro'

import {
  Currency,
  RecurringSubscriptionInterval,
} from '@jotta/grpc-connect-openapi/payment'

import { getEnumKey } from './enum'

export type Money = {
  amount: bigint | number
  currency: Currency
}

export const formatPrice = (
  { amount, currency }: Money,
  locale: Intl.LocalesArgument,
) => {
  return formatCurrency(Number(amount), currency, locale)
}

export const formatPriceConnect = (
  { amount, currency }: Money,
  locale: Intl.LocalesArgument,
): string => {
  return formatCurrency(Number(amount), currency, locale)
}

export const formatPriceConnectWithInterval = (
  interval: RecurringSubscriptionInterval,
  { amount, currency }: Money,
  locale: Intl.LocalesArgument,
): string => {
  const intervalString =
    interval == RecurringSubscriptionInterval.YEARLY_RECURRING
      ? t`year`
      : t`month`
  return `${formatCurrency(Number(amount), currency, locale)} / ${intervalString}`
}

// See guidelines for price formatting:
// https://polaris.shopify.com/foundations/formatting-localized-currency
export function formatCurrency(
  amount_cents: number,
  currency: Currency,
  locale: Intl.LocalesArgument,
) {
  const centsAmount = amount_cents % 100
  const digits = centsAmount === 0 ? 0 : 2
  const currencyFormat = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: getEnumKey(Currency, currency),
    currencyDisplay: 'narrowSymbol',
    maximumFractionDigits: digits,
    minimumFractionDigits: digits,
  })
  const formatted = currencyFormat.format(amount_cents / 100)
  return formatted.endsWith('.') ? formatted.slice(undefined, -1) : formatted
}
